import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../store/typeMessages'
import moment from 'moment'
import { Badge, Button, Dropdown, Menu } from 'antd'
import style from './Notifications.less'
import Push from 'push.js'
import { Link } from 'react-router-dom'

const Item = Menu.Item

const upper = (str) => str.replace(/^\w/, c => c.toUpperCase())

const unit = {
  pressure: v => `${v} PSI`,
  cfpressure: v => `${v} PSI`,
  temperature: v => `${v}  F`,
  cftemperature: v => `${v}  F`,
  cfflow: v => `${v}  mci/h`,
  power: v => v ? 'ON' : 'OFF',
  slunt1: v => v ? 'ON' : 'OFF',
  slunt2: v => v ? 'ON' : 'OFF',
}

const format = (n) => {
  return `${upper(n.location)} ${upper(n.name)} ${unit[n.name](n.lastValue)}`
}

class Notifications extends Component {
  constructor (props) {
    super(props)
    this.state = { lastRead: 0, lastPushNotification: 0 }
    if (!Push.Permission.has()) Push.Permission.request()
  }

  isRead (notification) {
    return notification.lastUpdate > this.state.lastRead
      ? { ...notification, read: true }
      : { ...notification, read: false }
  }

  down (visible) {
    // check if the menu is closed and update lastRead
    if (visible || this.props.notifications.length < 1) return
    let lastUpdate = this.props.notifications[0].lastUpdate
    this.setState({ lastRead: lastUpdate })
  }
  
  count () {
    return this.props.notifications
      .filter(n => n.lastUpdate > this.state.lastRead)
      .length
  }

  componentDidUpdate () {
    this.props.notifications
      .filter(n => n.lastUpdate > this.state.lastPushNotification)
      .map(n => {
        Push.create(format(n), {
          body: `Warning  ${moment(n.lastUpdate).format('MMMM DD YYYY, HH:mm:ss')}`,
          icon: '/img/icon-notifications.png'
        })
        this.setState({ lastPushNotification: n.lastUpdate })
        return n
      })
  }

  render () {
    let { notifications } = this.props
    const itemGenerator = (n, i) => {
      return (
        <Item key={i} style={{ backgroundColor: n.read ? '#fff' : '#f5f5f5' }}>
          <Link to={n.route}>
            {upper(n.location)} {upper(n.name)} <b>{unit[n.name](n.lastValue)}</b>
            <br />
            <span style={{ fontSize: '11px' }}>
              Warning {moment(n.lastUpdate).format('MMMM DD YYYY, HH:mm:ss')}
            </span>
          </Link>
        </Item>
      )
    }

    const menu = (
      <Menu className={style.notificationsMenu}>
        { notifications.length > 0
          ? notifications.map(this.isRead.bind(this)).map(itemGenerator)
          : <Item> No hay Notifiaciones </Item> }
      </Menu>
    )

    return (
      <div style={{ display: 'inline-block', float: 'right', marginRight: '10px' }}>
        <Badge dot count={this.count.bind(this)()} offset={[31, -33]} >
          <Dropdown
            onVisibleChange={this.down.bind(this)}
            overlay={menu}
            trigger={['click']}
            placement='bottomRight'>
            <Button icon='bell' className='btn-border-less' />
          </Dropdown>
        </Badge>
      </div>
    )
  }
}

/*
 * Conect to redux data
 */

function mapStateToProps (state) {
  return { notifications: state.notifications }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/utils/Notifications.js